import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TableHeaderTitleCell } from '../system-container/report/TableHeaderTitleCell'
import { EerResultsTableRow } from './EerResultsTableRow'
import { purchasedEnergySubCategories } from '../../provider/result-categories'
import { CalculatedVersion } from '../../calculators/use-calculator'

const useStyles = makeStyles({
  bold: {
    fontWeight: 'bold',
    fontFamily: 'Mukta',
  },
})

type Props = {
  eerVersions: CalculatedVersion[]
}

export function DetailedEerResultsTable({
  eerVersions,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderTitleCell title="" />
          {eerVersions.map((version) => (
            <TableCell
              className={classes.bold}
              key={`total-header-${version.id}`}
              align="center"
            >
              {version.name}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {purchasedEnergySubCategories.map((subCategory) => (
          <EerResultsTableRow
            key={`eer-${subCategory.purchasedEnergyType}`}
            title={t(`purchasedEnergyType.${subCategory.purchasedEnergyType}`)}
            versions={eerVersions}
            purchasedEnergySubCategories={[subCategory]}
            increasePrecision
          />
        ))}
      </TableBody>
    </Table>
  )
}
